import React from 'react';

function About() {
  return (
    <div className="" id='about'>
      <div className="">
        <h2 className="text-5xl  text-sky-600" style={{textAlign:'center'}}>About Apna Samay</h2>
        <p className="text-lg  m-9">
          Apna Samay is a simple and easy-to-use website that allows you to view a digital clock and set alarms. With its intuitive interface, you can quickly set up your alarm and get notified when it's time to take action.
          The website features a sleek design and is optimized for both desktop and mobile devices. You can access Apna Samay from anywhere in the world, making it a convenient tool for people who are always on the go.
          Apna Samay also offers a range of customization options, allowing you to choose from different clock styles and alarm sounds. You can even set a custom label for each alarm, making it easier to keep track of multiple reminders.
          Our team at Apna Samay is dedicated to providing a high-quality user experience, and we're constantly working on adding new features and improving existing ones. We value your feedback and suggestions, so please feel free to reach out to us with any comments or questions.
          Thank you for using Apna Samay! We hope it helps you stay organized and on schedule.
        </p>
        
      </div>
    </div>
  );
}

export default About;
